interface SectionTitleProps {
  title?: string;
  subtitle?: string;
  className?: string;
  eyeBrow?: boolean;
  textColor?: string;
}

export const SectionTitle = ({
  title,
  subtitle,
  className,
  eyeBrow = false,
  textColor = "text-primary-text",
}: SectionTitleProps) => {
  if (!title && !subtitle) {
    return null;
  }

  return (
    <div className={`block text-center ${textColor || ""} ${className || ""}`}>
      {eyeBrow && (
        <div className="eyebrow mb-2 opacity-70">Natalia y David</div>
      )}
      {title && (
        <div className="max-w-4xl m-auto text-5xl leading-none md:text-6xl font-light font-script">
          {title}
        </div>
      )}
      {subtitle && (
        <div className="mt-5 max-w-2xl m-auto text-lg leading-relaxed md:text-xl opacity-90">
          {subtitle}
        </div>
      )}
    </div>
  );
};

export const SectionSubTitle = ({
  title,
  subtitle,
  className,
  textColor = "text-primary-text",
}: SectionTitleProps) => {
  if (!title && !subtitle) {
    return null;
  }

  return (
    <div className={`block text-center  ${textColor || ""} ${className || ""}`}>
      {title && (
        <div className="text-4xl leading-none md:text-5xl font-script">
          {title}
        </div>
      )}
      {subtitle && (
        <div className="mt-3 text-lg md:text-xl opacity-90">{subtitle}</div>
      )}
    </div>
  );
};
